import { render, staticRenderFns } from "./TeOfrece.vue?vue&type=template&id=72f48cb7&scoped=true&"
import script from "./TeOfrece.vue?vue&type=script&lang=js&"
export * from "./TeOfrece.vue?vue&type=script&lang=js&"
import style0 from "./TeOfrece.vue?vue&type=style&index=0&id=72f48cb7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72f48cb7",
  null
  
)

export default component.exports